import { render, staticRenderFns } from "./MessageCardPage.vue?vue&type=template&id=740776d2&scoped=true&lang=pug&"
import script from "./MessageCardPage.vue?vue&type=script&lang=ts&"
export * from "./MessageCardPage.vue?vue&type=script&lang=ts&"
import style0 from "./MessageCardPage.vue?vue&type=style&index=0&id=740776d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740776d2",
  null
  
)

export default component.exports